var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.4193 17 17 13.4193 17 9C17 4.58074 13.4193 1 9 1M9 17C4.58074 17 1 13.4193 1 9C1 4.58074 4.58074 1 9 1M9 17V1M5.52125 1.88385C5.52125 1.88385 4.3881 4.52408 4.3881 9C4.3881 13.4759 5.52125 16.1161 5.52125 16.1161M12.6714 16.1161C12.6714 16.1161 13.8045 13.4759 13.8045 9C13.8045 4.52408 12.6714 1.88385 12.6714 1.88385M1.73654 6.17847H16.2521M1.73654 11.8215H16.2521",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.ea367bd51d6df85db6d123f148dbce29.svg";
export { ForwardRef as ReactComponent };